<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'CATALOGOS GENERALES' }]">
      </app-breadcrumb>
    </div>

    <app-top-widgets/>

    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <mat-tab-group>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">apps</mat-icon>
                BASICOS
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-basic-list/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">assignment</mat-icon>
                DIAGNOSTICOS
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-diagnostics-list/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">local_post_office</mat-icon>
                CODIGO POSTAL
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-postal-code-list/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">map</mat-icon>
                ENTIDADES
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-entity-list/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">my_location</mat-icon>
                MUNICIPIOS
              </ng-template>
              <ng-template matTabContent>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="project_widget">
                    <div class="body">
                      <app-township-list/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-tab>

          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>
